/* To create a datepicker, make your date field a text input and give it the class 'sbf-datepicker'
 *  ie: <input type="text" name="birthday" class="sbf-datepicker">
 *
 * EVENTS:
 *
 * * sbf.dateInit:
 *   This fires after the date fields have been created.
 *   $('#someDatePicker').bind('sbf.dateInit', function () {
 *      // ...
 *   });
 *
 * * sbf.dateChange:
 *   This fires anytime the date value changes.
 *   $('#someDatePicker').bind('sbf.dateChange', function () {
 *      // ...
 *   });
 *
 * OPTIONS:
 *
 * * Initial Date:
 *   Set the value of the input to the initial date in the form YYYY-MM-DD
 *   <input type="text" ... value="1985-12-27">
 *
 * * Default Date:
 *   <input type="text" name="date" class="sbf-datepicker" data-sbf-datepicker-default="1985-12-27">
 *   shortcut for today's date:
 *   <input type="text" ... data-sbf-datepicker-default="today">
 *
 * You can optionally specify a type using the 'data-sbf-datepicker-type' attribute (currently there
 * is only one type)
 *  ie: <input type="text" name="birthday" class="sbf-datepicker" data-sbf-datepicker-type="basic">
 *
 * That's it. (Currently there is no related css file)
 */
!function (w, $) {

    if (!w.sbf) {
        w.sbf = {};
    }

    var count = 0;

    var month_options_html = '<option value=""></option>',
        months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    for (var i=0, l = 12; i < l; i++) {
        var val = i+1;
        if (val < 10) {
            val = '0' + val;
        }
        month_options_html += '<option value="' + val + '">' + months[i] + '</options>';
    }

    var day_options_html = '<option value=""></option>';

    for (var i = 1, x = 31; i <= x; i++) {
        var val = i < 10 ? '0' + i : i;
        day_options_html += '<option value="'+val+'">' + i + '</option>';
    }

//    var year_options_html = '';
//
//  for (var i = 1900, x = (new Date).getFullYear(); i <= x; i++) {
//      year_options_html += '<option value="'+i+'">' + i + '</option>';
//  }

    function get_year_options_html (lowerLimit, upperLimit) {
        var this_year = (new Date).getFullYear();
        if (!lowerLimit) lowerLimit = this_year - 100;
        if (!upperLimit) upperLimit = this_year;

        //AC1998: (December 19, 2011) tyler.lemburg moved the "default" blank to the
        //bottom and made it not appear if actual years were placed in the select
        var year_options_html = '<option value=""></option>';

        for (var i = upperLimit, x = lowerLimit; i >= x; i--) {
            year_options_html += '<option value="'+i+'">' + i + '</option>';
        }

        return year_options_html;
    }

    var today = new Date();

    sbf.datepicker = {

        today: today.getFullYear() + '-' + (parseInt(today.getMonth()) + 1) + '-' + today.getDate(),

        getDateObject: function (dateString) {
            if (dateString.match(/\d\d\d\d\-\d+\-\d+/)) {
                var year = dateString.substring(0,4),
                    month = dateString.match(/-(\d+)-/)[1],
                    day = dateString.match(/-(\d+)$/)[1];
                    var validDate = true;
                    switch (month) {
                        case "02":
                            if (year % 4 == 0) {
                                if (day > 29) {
                                    validDate = false;
                                }
                            }
                            else {
                                if (day > 28) {
                                    validDate = false;
                                }
                            }
                            break;
                        case "04":
                        case "06":
                        case "09":
                        case "11":
                            if (day > 30) {
                                validDate = false;
                            }
                            break;
                        default:
                            if (day > 31) {
                                validDate = false;
                            }
                    }
                if (validDate) {
                    return new Date(month + '/' + day + '/' + year);
                } else {
                    return "invalid";
                }
            }
            return null;
        },

        types: {

            /* basic type replaces a text input with month, day, and year selectors */
            'basic': {

                setup: function (i, $input) {

                    var year_range = $input.attr('data-sbf-datepicker-years');
                    var year_options_html;

                    // match YYYY-YYYY
                    if (year_range && year_range.match(/\d{4}-\d{4}/)) {
                        year_options_html = get_year_options_html(year_range.substring(0, 4), year_range.substring(5,9));
                    } else {
                        year_options_html = get_year_options_html();
                    }

                    var month_select = $('<select id="sbf-datepicker-' + i + '-month">' + month_options_html + '</select>'),

                        day_select = $('<select id="sbf-datepicker-' + i + '-day">' + day_options_html + '</select>'),

                        year_select = $('<select id="sbf-datepicker-' + i + '-year">' + year_options_html + '</select>');


                    $input.hide();
                    $input.parent().append(month_select, ' ', day_select, ' ', year_select);

                    // set the correct initial date if there is one

                    // use a test value:
//                    $input.val('1985-12-27');

                    var initial_date = $input.val(),
                        default_date = $input.attr('data-sbf-datepicker-default');

                    if ((!initial_date || initial_date == '') && default_date) {

                        if (default_date == 'today') {
                            default_date = sbf.datepicker.today;
                        }
                        initial_date = default_date;
                        $input.val(default_date);
                    }

                    if (initial_date.match(/\d\d\d\d\-\d+\-\d+/)) {

                        var initial_date_array = initial_date.split('-');

                        if (parseInt(initial_date_array[1]) < 10 && initial_date_array[1].length == 1) {
                            initial_date_array[1] = '0' + parseInt(initial_date_array[1]);
                        }
                        if (parseInt(initial_date_array[2]) < 10 && initial_date_array[2].length == 1) {
                            initial_date_array[2] = '0' + parseInt(initial_date_array[2]);
                        }
                        month_select.val(initial_date_array[1]);
                        day_select.val(initial_date_array[2]);
                        year_select.val(initial_date_array[0]);

                    } else {
                        // date format doesn't match yyyy-mm-dd
                    }

                    function updateDate (evt) {
                        var new_date = year_select.val() + '-' + month_select.val() + '-' + day_select.val();
                        $input.val(new_date);
                        $input.trigger('sbf.dateChange');
                    }

                    var new_date = year_select.val() + '-' + month_select.val() + '-' + day_select.val();
                    $input.val(new_date);

                    month_select.bind('change', updateDate);
                    day_select.bind('change', updateDate);
                    year_select.bind('change', updateDate);

                }

            }
        },

        DEFAULT_TYPE: 'basic',

        init: function () {
            $('.sbf-datepicker').each(function() {
                var $this = $(this),
                    type = $this.attr('data-sbf-datepicker-type'),
                    id = $this.attr('data-sbf-datepicker-id');

                // don't setup an element more than once
                if (!id) {
                    var i = count++;
                    if (!sbf.datepicker.types[type]) {
                        type = sbf.datepicker.DEFAULT_TYPE;
                    }
                    sbf.datepicker.types[type].setup(i, $this);
                    $this.attr('data-sbf-datepicker-id', i);
                    $this.trigger('sbf.dateInit');
                }
            });
        }
    };

    $(sbf.datepicker.init);
}(window, jQuery);
